
import React from 'react';
import { clients } from './data';
import ClientsMobileView from './ClientsMobileView';
import ClientsDesktopView from './ClientsDesktopView';
import TwoRowsLogoCarousel from './TwoRowsLogoCarousel';

const ClientLogos: React.FC = () => {
  return (
    <div className="mt-10">
      {/* Using TwoRowsLogoCarousel for all devices with grayscale effect */}
      <TwoRowsLogoCarousel clients={clients} grayscale={true} />
    </div>
  );
};

export default ClientLogos;
